import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { WA_TORTE } from "./Navbar";

const TORTE_IMG =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_dolce-portfolio/artifacts/8d0accd9b7b9d620_gpt-image-2.5-sunburst_inserisci_al_posto_della_brioche_presente_nell_immagine_di_reference_quella_con_-0%20%281%29.webp";

const STEPS = [
  {
    n: "01",
    title: "Scrivici su WhatsApp",
    text: "Raccontaci l'occasione: compleanno, cerimonia o un semplice momento speciale.",
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] },
  }),
};

export const Torte = () => (
  <section id="torte" className="py-24 sm:py-32 border-t border-[#e6dacb] bg-[#f4ede4]/50" data-testid="torte-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-60px" }}
          className="relative rounded-3xl overflow-hidden aspect-[4/3] max-w-lg border border-[#e6dacb] order-2 lg:order-1"
        >
          <img
            src={TORTE_IMG}
            alt="Torta al cioccolato con frutti di bosco freschi su alzatina"
            loading="lazy"
            className="w-full h-full object-cover"
            data-testid="torte-image"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" />
        </motion.div>

        <div className="order-1 lg:order-2">
          <motion.p
            variants={fadeUp}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="flex items-center gap-4 text-[0.7rem] uppercase tracking-[0.35em] font-medium text-[#84232a] mb-6"
            data-testid="torte-eyebrow"
          >
            <span className="w-10 h-px bg-[#84232a]/50" />
            Torte su ordinazione
          </motion.p>

          <motion.h2
            variants={fadeUp}
            custom={1}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="font-display text-5xl sm:text-6xl font-medium text-black leading-[1.02]"
            data-testid="torte-title"
          >
            La tua torta,{" "}
            <span className="font-script text-[#84232a] font-normal">come la sogni.</span>
          </motion.h2>

          <motion.p
            variants={fadeUp}
            custom={2}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="text-[#4a423d] text-base sm:text-lg leading-relaxed mt-7 max-w-md font-light"
            data-testid="torte-text"
          >
            Compleanni, cerimonie, eventi: ogni torta nasce nel nostro laboratorio
            con ingredienti selezionati e una decorazione pensata solo per te.
          </motion.p>

          <div className="mt-10 max-w-md">
            {STEPS.map((s, i) => (
              <motion.div
                key={s.n}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true, margin: "-40px" }}
                className="flex gap-6 border-t border-[#e6dacb] py-5 last:border-b"
                data-testid={`torte-step-${i}`}
              >
                <span className="font-display text-xl text-[#84232a] w-8 shrink-0">{s.n}</span>
                <div>
                  <h3 className="font-display text-xl font-semibold text-black">{s.title}</h3>
                  <p className="text-[#4a423d] text-sm mt-1 leading-relaxed">{s.text}</p>
                </div>
              </motion.div>
            ))}
          </div>

          <motion.div
            variants={fadeUp}
            custom={4}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            className="mt-9"
          >
            <a
              href={WA_TORTE}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="torte-cta-whatsapp"
              className="group inline-flex items-center gap-3 bg-[#84232a] text-[#fbf6f1] px-8 py-4 rounded-full text-sm font-medium hover:bg-[#63191f] transition-colors duration-300"
            >
              <MessageCircle className="w-4 h-4 transition-transform duration-300 group-hover:rotate-12" />
              Prenota la tua torta
            </a>
          </motion.div>
        </div>
      </div>
    </div>
  </section>
);
